// extracted by mini-css-extract-plugin
export default {"base":"InfoCard_base__tEtyr"};